import Button from '@Hotels-at-Home/hah-fe-core/dist/components/Button';
import { Trans, useTranslation } from 'next-i18next';
import BedTime from './BedTime';
import { useEffect, useRef } from 'react';
import Link from '@Hotels-at-Home/hah-fe-core/dist/components/Link';

const BedSection = () => {
  const { t: tButton } = useTranslation('', { keyPrefix: '$common.$buttons' });
  const { t: tBed } = useTranslation('', { keyPrefix: '$pages.$home.$bedSection' });
  const { t: tLink } = useTranslation('', { keyPrefix: '$local.$homePageLinks.$bed' });
  const times = ['day', 'dusk', 'night'];
  const container = useRef(null);
  const onScroll = () => {
    if (!container.current) return;
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const top = container.current.offsetTop;
    const nightOpacity = (top - scrollTop - 100) / 500; // subtract 100 to accomodate for sticky header
    const duskOpacity = (top - scrollTop - 100) / 200; //     ↑
    const nightImg = container.current.querySelector('.night');
    const duskImg = container.current.querySelector('.dusk');
    if (nightImg) nightImg.style.opacity = nightOpacity;
    if (duskImg) duskImg.style.opacity = duskOpacity;
  };
  useEffect(() => {
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return (
    <section className="base-section bed-section hp-section" ref={container}>
      <div className="desktop-viewport">
        <Link href={tLink('mattressAndBase')}>
          <div className="content-section">
            <h2>{tBed('title')}</h2>
          </div>
          <div className="stack">
            <h3>
              <Trans i18nKey="stackTitle" t={tBed} components={{ span: <span /> }} />
            </h3>
            <p className="sub-copy">{tBed('description')}</p>
            <Button ariaLabel={tBed('bedAlt')}>{tButton('shopNow')}</Button>
          </div>
          <div className="time-wrap">
            {times.map(time => (
              <BedTime key={time} time={time} />
            ))}
          </div>
        </Link>
      </div>
    </section>
  );
};
export default BedSection;
